import React from 'react';
import { useOffer } from '../contexts/OfferContext';
import { valueMathConfig } from '../data/siteConfig';
export const ValueMathSection = () => {
  const {
    price,
    priceLabel
  } = useOffer();
  const perDay = Math.round(price / 365);
  const rows = [<>
      Una sola sesión particular de estimulación o kinesiología a domicilio
      cuesta{' '}
      <span className="font-bold text-familia-ink" data-id="element-296" data-mp="sjx7rkghbrk5">
        {valueMathConfig.sesionDomicilio}
      </span>
      . Es una hora, una vez.{' '}
      <span className="font-bold text-familia-ink" data-id="element-297" data-mp="3vzci6msrs35t">
        Esto lo usás todo el año.
      </span>
    </>, <>
      Un cuadernillo de estimulación en librería sale{' '}
      <span className="font-bold text-familia-ink" data-id="element-298" data-mp="9rcjyhfn0cn7">
        {valueMathConfig.cuadernilloLibreria}
      </span>{' '}
      y trae un solo tipo de actividad.
    </>, <>
      Buscar, adaptar y graduar 150 actividades vos solo te llevaría{' '}
      <span className="font-bold text-familia-ink" data-id="element-299" data-mp="1l5gf3qxyo6tu">semanas</span>.
    </>];
  return <section className="bg-familia-light border-t border-familia-lightBorder py-12 md:py-16 px-4 md:px-6" data-id="element-300" data-mp="1j97l501s7muk">
      <div className="max-w-3xl mx-auto w-full" data-id="element-301" data-mp="1o6zmekobglbf">
        <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-familia-ink text-center mb-8 md:mb-10 leading-tight" data-id="element-302" data-mp="1o9vl4b7zne0x">
          ¿Por qué {priceLabel} es poco?{' '}
          <span className="text-familia-accent" data-id="element-303" data-mp="1x7o17hljappd">Hagamos la cuenta.</span>
        </h2>
        <div className="bg-familia-lightCard border border-familia-lightBorder rounded-2xl overflow-hidden" data-id="element-304" data-mp="10jrj28ag7mc1">
          <ul className="divide-y divide-familia-lightBorder" data-id="element-305" data-mp="14k1o9iqf28pu">
            {rows.map((row, i) => <li key={i} className="text-body text-familia-inkMuted px-6 md:px-8 py-5" data-id="element-306" data-mp="19i38i6zkwe2w" data-mpi={i}>
                {row}
              </li>)}
          </ul>
          <div className="bg-familia-ink text-white px-6 md:px-8 py-6 flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1" data-id="element-307" data-mp="gu7a8xud2e40">
            <span className="text-body text-familia-onDarkMuted" data-id="element-308" data-mp="ls8w1qj68rj6">
              Si lo usás un año, te sale unos
            </span>
            <span className="font-display font-bold text-3xl md:text-4xl text-familia-gold whitespace-nowrap" data-id="element-309" data-mp="1p2d5n34vuu3n">
              ${perDay} por día
            </span>
          </div>
        </div>
        <p className="text-body font-semibold text-familia-ink text-center mt-6 md:mt-8" data-id="element-310" data-mp="1xvq9h04hjg4i">
          Y lo imprimís las veces que quieras: para tu mamá, para la tía y para
          el cuidador.
        </p>
      </div>
    </section>;
};